<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-form v-on:submit.prevent="guardarCodigo">
      <b-row>
        <b-col class="text-left">
          <label>Código postal:</label>
          <b-form-input
            maxlength="5"
            v-model="codigo"
            placeholder="Código postal: "
            :state="codigo.length == 5"
            required
          ></b-form-input>
        </b-col>
        <b-col class="text-left">
          <label>Colonia:</label>
          <b-form-input
            v-model="colonia"
            placeholder="Colonia: "
            :state="colonia.length != 0"
            required
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="mt-4 mb-4">
        <b-col class="text-left">
          <label>Estado:</label>
          <b-form-select
            v-model="estadoSeleccionado"
            :options="listaEstados"
            value-field="idEstado"
            text-field="nombreEstado"
            v-on:change="buscarColonias"
            :state="estadoSeleccionado != null"
            required
          ></b-form-select
        ></b-col>
        <b-col class="text-left">
          <label>Municipio:</label>
          <b-form-select
            v-model="localidadSeleccionado"
            :options="listaLocalidades"
            value-field="idMunicipio"
            text-field="nombreMunicipio"
            :state="localidadSeleccionado != null"
            required
          ></b-form-select
        ></b-col>
      </b-row>

      <b-button type="submit" variant="outline-primary" v-if="!enviando"
        >Guardar</b-button
      >
      <b-button variant="primary" v-show="enviando" disabled>
        <b-spinner small></b-spinner>
        Cargando...
      </b-button>
    </b-form>
  </div>
</template>

<script>
import VueNotifications from "vue-notifications";

export default {
  name: "AltaCp",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    codigo: "",
    colonia: "",
    listaEstados: [],
    estadoSeleccionado: null,
    listaLocalidades: [],
    localidadSeleccionado: null,
    enviando: false,
  }),
  created() {
    //traemos los estados
    this.buscarEstados();
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    buscarEstados() {
      let supper = this;
      const urlEstados = this.$api + "catalogos/listaEstados";

      this.$http
        .get(urlEstados)
        .then(function (response) {
          if (response.data.data) {
            let tituloEstado = {
              idEstado: null,
              nombreEstado: "Estado: ",
            };
            response.data.data.unshift(tituloEstado);
            supper.listaEstados = response.data.data;
          }
        })
        .catch(function (err) {
          supper.showErrorMsg(err);
        });
    },
    buscarColonias() {
      if (this.estadoSeleccionado != null) {
        let supper = this;

        const urlMunicipios =
          this.$api +
          "catalogos/listaMunicipios?idEstado=" +
          this.estadoSeleccionado;
        this.$http
          .get(urlMunicipios)
          .then(function (response) {
            if (response.data.data) {
              let tituloMunicipio = {
                idMunicipio: null,
                nombreMunicipio: "Municipio: ",
              };
              response.data.data.unshift(tituloMunicipio);
              supper.listaLocalidades = response.data.data;
            }
          })
          .catch(function (err) {
            supper.showErrorMsg(err);
          });
      }
    },
    guardarCodigo() {
      //validamos campos
      const campos = this.validarCampos();

      if (campos) {
        let supper = this;
        this.enviando = true;

        // guardamos los datos
        const urlGuardarCp = this.$api + "localidad";
        this.$http
          .post(urlGuardarCp, this.traerDatos())
          .then(function (response) {
            if (response.data.data) {
              supper.$swal({
                icon: "success",
                text: "Información guardada correctamente",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
              supper.enviando = false;
            } else {
              supper.$swal({
                icon: "error",
                text:
                  "No se puede ingresar un código en otro estado y municipio",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
              supper.enviando = false;
            }
          })
          .catch(function (err) {
            supper.showErrorGuardar(err);
            supper.enviando = false;
          });
      }
    },
    validarCampos() {
      let escogido = true;
      this.codigo = this.codigo.trim();
      if (this.codigo.length < 5 || isNaN(this.codigo)) {
        this.$swal({
          icon: "error",
          text:
            "El codigo postal ingresado no es válido, debe tener solo 5 números",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        escogido = false;
      }

      return escogido;
    },
    traerDatos() {
      return {
        codigoPostal: this.codigo,
        nombreLocalidad: this.colonia.trim().toUpperCase(),
        idMunicipio: this.localidadSeleccionado,
        idEstado: this.estadoSeleccionado,
        idUsuarioLog: this.$localStorageService.getIdUsuario(),
      };
    },
  },
  notifications: {
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    showErrorGuardar: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al guardar la información",
    },
  },
};
</script>